// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2025project/q1/2025journalist/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

const getVoteList = (page: number, search: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      search
    },
  });
};

const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const vote = (
  data: {
    id: number | string;
    udid?: any;
    appkey?: any;
    code?: any;
    csessionid?: string;
    scene?: string;
    sig?: string;
    token?: string;
    source: number | string;
  },
) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}vote`, qsData);
}

export { getBaseInfo, getRule, getVoteList, vote, getDetail };
